export default "__VITE_ASSET__DQWIFaCN__"